import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createQrSession,
  findQrSession,
  markQrSessionUsed,
} from "../db/qrSessionRepository";

export function useCreateQrSession() {
  return useMutation({
    mutationFn: ({
      token,
      expiresAt,
      authAccessToken,
      authRefreshToken,
    }: {
      token: string;
      expiresAt: string;
      authAccessToken?: string;
      authRefreshToken?: string;
    }) => createQrSession(token, expiresAt, authAccessToken, authRefreshToken),
  });
}

export function useQrSessionStatus(token: string | null) {
  return useQuery({
    queryKey: ["qrSessions", token],
    queryFn: () => findQrSession(token!),
    enabled: !!token,
    refetchInterval: 300,
  });
}

export function useClaimQrSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ token, userId }: { token: string; userId: string }) =>
      markQrSessionUsed(token, userId),
    onSuccess: (_data, { token }) => {
      queryClient.invalidateQueries({ queryKey: ["qrSessions", token] });
    },
  });
}
